import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   DoCheck,
   Input,
   OnDestroy,
   OnInit,
   ViewEncapsulation,
} from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { ExtensionTypes, TimeZones } from 'generated/graphql-types';
import { copyNameControlToShortNameAndDisplayName } from 'src/app/common-components/helpers/extension-form-helper';
import { ExtensionTypeDetails } from '../../models/extension-type-details';
import { GetExtensionDetail_extension_extensionMailbox } from '../../queries/generated/GetExtensionDetail';

@Component({
   changeDetection: ChangeDetectionStrategy.OnPush,
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-extension-mail-box-details',
   styleUrls: ['./extension-mail-box-details.component.scss'],
   templateUrl: './extension-mail-box-details.component.html',
   standalone: false,
})
export class ExtensionMailboxDetailsComponent extends ExtensionTypeDetails implements OnInit, OnDestroy, DoCheck {
   @Input() extensionMailbox: GetExtensionDetail_extension_extensionMailbox | null;

   @Input() accountId: number | null;

   @Input() extensionType: ExtensionTypes | null;

   @Input() timeZoneId: TimeZones | null;

   form: UntypedFormGroup;

   readonly ExtensionTypes = ExtensionTypes;

   constructor(
      private changeDetectorRef: ChangeDetectorRef,
      private controlContainer: ControlContainer,
      private parentForm: FormGroupDirective
   ) {
      super();
   }

   ngOnDestroy(): void {
      this.extensionMailbox = null;
   }

   ngOnInit(): void {
      this.form = <UntypedFormGroup>this.controlContainer.control;
      copyNameControlToShortNameAndDisplayName(this.parentForm.form, this.form);
   }

   ngDoCheck(): void {
      if (this.parentForm.form.invalid && (this.parentForm.submitted || this.form.touched)) {
         this.form.markAllAsTouched();
         this.changeDetectorRef.markForCheck();
      }
   }
}
